// Skirmish setup screen entry (GDD §11): the SetupScreenFactory seam used by the app flow (match/contracts.ts), and
// the match seed source the flow's rematch shares.

import type { SetupScreenFactory } from '../../match/contracts'
import { SetupScreen } from './SetupScreen'

export { randomSeed } from './seed'

export const setupScreen: SetupScreenFactory = (actions, challenge) => (context) => new SetupScreen(context, actions, challenge)
